import Decimal from 'decimal.js'

const doCustomCalculation = (calcRef, value = 0, argValues = []) => {
  if (!calcRef?.method) {
    return value
  }

  const castedValue = !isNaN(parseFloat(value)) ? parseFloat(value) : 0
  switch (calcRef.method) {
    case 'shareoftax': {
      const vatRate = calcRef.args?.[0] ?? 0
      const vatRateDec = Decimal.div(vatRate, 100)
      const netto = castedValue
      const vatAmount = Decimal.mul(netto, vatRateDec).toDP(2, Decimal.ROUND_HALF_UP).toNumber()
      return vatAmount
    }
    case 'sum': {
      return argValues.reduce((a, b) => Decimal.add(a, b), new Decimal(0)).toDP(2, Decimal.ROUND_HALF_UP).toNumber()
    }
    case 'sub': {
      const minuend = new Decimal(argValues.shift() || 0)
      const difference = argValues.reduce((a, b) => Decimal.sub(a, b), minuend)
      return difference.toDP(2, Decimal.ROUND_HALF_UP).toNumber()
    }
    case 'lte': {
      const first = argValues[0] || 0
      const second = argValues[1] || 0
      return first <= second
    }
    case 'gt': {
      const first = argValues[0] || 0
      const second = argValues[1] || 0
      return first > second
    }
    default:
      return value
  }
}

const getArgValues = (calcRef, dataSource, transientFormValueHandler = null) => {
  if (!calcRef?.args || !dataSource) {
    return []
  }

  return calcRef.args.map(elm => {
    if (typeof elm === 'string') {
      // elm represent no number type, so its a binding name and get the value from source
      return transientFormValueHandler && transientFormValueHandler.get('active')
        ? transientFormValueHandler.get(elm) ?? (dataSource[elm] || 0)
        : dataSource[elm] || 0
    }

    return elm
  })
}

const createTransientFormValueHandler = (cacheObject = {}) => {
  return {
    getCache: () => cacheObject,
    start: () => (cacheObject = { active: true }),
    stop: () => (cacheObject = { active: false }),
    save: (binding, value) => (cacheObject[binding] = value),
    get: (binding) => cacheObject[binding] || null,
    update: (target) => {
      if (!target) {
        return null
      }

      return Object.entries(target).reduce((acc, [property, value]) => {
        if (cacheObject[property] != null) {
          acc[property] = cacheObject[property]
        } else {
          acc[property] = value
        }

        return acc
      }, {})
    },
  }
}

export {
  doCustomCalculation,
  getArgValues,
  createTransientFormValueHandler,
}
